import Navbar from "../components/navbar/Navbar";
import IRRAnalysis from "../components/irr-analysis/IRRAnalysis";

function IRRAnalysisScreen() {
  return (
    <div className="container-fluid bg-theme overflow-hidden" style={{ height: "100vh" }}>
      <div className="row h-100">
        <div className="d-flex flex-column align-items-center justify-content-start w-100 flex-grow-1 overflow-hidden" style={{ minHeight: 0 }}>
          <div className="w-100 mb-2 flex-shrink-0">
            <Navbar />
          </div>
          <div className="w-100 flex-grow-1 d-flex overflow-hidden" style={{ minHeight: 0 }}>
            <IRRAnalysis />
          </div>
        </div>
      </div>
    </div>
  );
}

export default IRRAnalysisScreen;
